export const IN_PROGRESS = "in_progress";
export const SHIP = "ship";
export const DELIVER = "deliver";
export const INVOICE = "invoice";